import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Feature, Module } from '@cbuild/shared';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs';
import { AuthenticationService } from './authentication/authentication.service';

interface Data {
  feature?: Array<Feature>;
  module?: Array<Module>;
  permissionCode?: Array<number>;
  fallback?: string;
}

/**
 * should have all the modules and feature permissions in the token
 * If at least one fails the guard returns false
 */
@Injectable()
export class PermissionGuard implements CanActivate {
  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.authService.authInitialized.pipe(
      map(_ => {
        let result = true;
        const data = route.data as Data;
        for (const module of data.module || []) {
          if (!this.authService.hasModulePermission(module)) {
            result = false;
            this.navigateIfHasFallback(data.fallback);
            break;
          }
        }
        const feature = data?.feature || [];
        for (let i = 0; i < feature.length; i++) {
          if (
            !this.authService.hasUserPermission(
              feature[i],
              data.permissionCode![i]
            )
          ) {
            result = false;
            this.navigateIfHasFallback(data.fallback);
            break;
          }
        }

        return result;
      }),
      take(1)
    );
  }

  private navigateIfHasFallback(fallback?: string): void {
    if (fallback) {
      fallback = fallback[0] !== '/' ? `/${fallback}` : fallback;
      this.router.navigateByUrl(fallback);
    } else {
      this.authService.navigateToNoAccess();
    }
  }
}
